module.exports = __webpack_public_path__ + "img/rosa_cha-w.466ea632.png";